module.exports = __webpack_public_path__ + "img/save-money.3682659d.svg";